<template>
    <app-layout :nav_type="null" :footer_image="false">
        <!-- Hero Start -->
        <section class=" bg-circle-gradiant d-flex align-items-center bg-half-170 ">
            <div class="bg-overlay bg-overlay-white"></div>
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-5 col-md-8">
                        <div class="card login-page shadow rounded border-0">
                            <div class="card-body">
                                <h4 class="card-title text-center mb-4">Check your email</h4>

                                <div class="verify">
                                    <p v-if="is_loading" class="text-center">Loading...</p>
                                    <p v-if="message" class="alert alert-success">{{ message }}</p>
                                    <p v-if="error" class="alert alert-danger">{{ error }}</p>
                                    <div class="text-center"  v-if=" ! is_loading">
                                        <router-link to="/" class="btn btn-primary btn-block">Go to Home</router-link>
                                    </div>
                                </div>

                            </div>
                        </div><!---->
                    </div><!--end col-->
                </div><!--end row-->
            </div> <!--end container-->
        </section><!--end section-->
        <!-- Hero End -->
    </app-layout>
</template>

<script>
import axios from 'axios';
import AppLayout from "../../app-layout.vue";

export default {
    components: {AppLayout},
    data() {
        return {
            message: '',
            error: '',
            is_loading: true
        };
    },
    created() {
        console.log('test');
        this.verifyEmail();
    },
    methods: {
        verifyEmail() {
            const token = this.$route.params.token;
            axios.post(`/auth/verify/${token}`)
                .then(response => {
                    this.message = response.data.message;
                    this.is_loading = false;
                })
                .catch(error => {
                    this.is_loading = false;
                    this.error = error.response.data.message || 'حدث خطأ أثناء محاولة التحقق من البريد الإلكتروني.';
                });
        }
    }
}
</script>

<style scoped>
.error {
    color: red;
}
</style>
